module.exports = "<footer class=\"container\">\n  <p>&copy; OldWildWeb Company 2018</p>\n</footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/template/foother/foother.component.html
// module id = ./src/app/template/foother/foother.component.html
// module chunks = main